/**
 * The disclosure chevron, and its one rule: it points RIGHT while what it
 * governs is closed and DOWN while it is open — the tree view's convention,
 * the one every file browser taught.
 *
 * WHY a component for a rotation. The card's folds pointed right-then-down,
 * while Second opinion — wearing the same fold class a few lines below — and
 * the feed's tuck and run toggle pointed down-then-up, so one glyph meant
 * "closed" on one control and "open" on the next (D335). The rule lives here so
 * a new disclosure cannot pick a third reading by writing its own transform.
 */

import type { CSSProperties } from 'react'
import { Icon } from './Icon'

export function Chevron({
  open,
  size = 9,
  className,
}: {
  open: boolean
  size?: number
  className?: string
}) {
  const style: CSSProperties = {
    flex: 'none',
    transform: open ? 'rotate(90deg)' : 'none',
    transition: 'transform 0.2s ease',
  }
  return <Icon name="chevron" size={size} className={className} style={style} />
}
